<div class="flx-row timer">
    <span class="time" id="day">{{ _days }}d</span> : <span class="time" id="hour">{{ _hours }}h</span> : <span class="time" id="minute">{{ _minutes }}m</span> : <span class="time" id="second">{{ _seconds }}s</span>
</div>